if (!customElements.get('progress-bar')) {
  customElements.define(
    'progress-bar',
    class ProgressBar extends HTMLElement {
      constructor() {
        super();
      }
    }
  );
}
